export const isPageLiveScore = () => window.location.pathname.includes('livescore')